import React from "react";
import { Typography, Box } from "@mui/material";
import Stack from "@mui/material/Stack";
import MzCheckbox from "@markaaz/ui/MzCheckbox";
import MzAlert from "@markaaz/ui/MzAlert";
const sx = {
  checkbox: (theme) => ({
    "& .MuiTypography-root": {
      ...theme.typography.body1,
      paddingLeft: "10px"
    },
    "& .MuiCheckbox-root": {
      color: theme.palette.darkBlue.c50
    },
    "& .Mui-checked": {
      color: theme.palette.blue.c100
    },
    paddingLeft: "20px",
    "&.Mui-disabled": {
      "& .MuiCheckbox-root": {
        color: theme.palette.darkBlue.c20
      },
      "& .MuiFormControlLabel-label": {
        color: theme.palette.darkBlue.c50
      }
    }
  })
};

function MonitoringConfiguration({
  checkBoxValues,
  permissions,
  showAlert,
  onDisabledSection,
  onAlertClose,
  onCheckBoxChange
}) {
  const disableBusinessMonitoring =
    permissions.businessMonitoring && (checkBoxValues.addMatches || checkBoxValues.addNonMatches);
  const disableComplianceMonitoring =
    permissions.complianceMonitoring && (checkBoxValues.addMatches || checkBoxValues.addNonMatches);
  const checkAlert =
    !checkBoxValues.addEntityPortfolio || !permissions.businessMonitoring || !permissions.complianceMonitoring;
  return (
    <Box p={5}>
      <Typography variant="body1M" color="blue.c100">
        Enable Monitoring for Matches
      </Typography>
      <Typography variant="body2" mt={1} mb={4}>
        Select whether you would like to enable monitoring for matches for this entity. The ability to enable monitoring
        is dependent on the contract terms for your account.
      </Typography>
      <Box sx={{ display: "flex" }}>
        <Stack>
          <Box onClick={!disableBusinessMonitoring ? () => onDisabledSection("monitoring") : null}>
            <MzCheckbox
              label="Business Monitoring"
              name="businessMonitoring"
              checked={checkBoxValues.businessMonitoring}
              disabled={!disableBusinessMonitoring}
              onChange={onCheckBoxChange}
              sx={sx.checkbox}
            ></MzCheckbox>
          </Box>
          <Box onClick={!disableComplianceMonitoring ? () => onDisabledSection("monitoring") : null}>
            <MzCheckbox
              label="Compliance Monitoring"
              name="complianceMonitoring"
              checked={checkBoxValues.complianceMonitoring}
              disabled={!disableComplianceMonitoring}
              onChange={onCheckBoxChange}
              sx={sx.checkbox}
            ></MzCheckbox>
          </Box>
        </Stack>

        {showAlert.monitoring && checkAlert && (
          <MzAlert
            severity="error"
            sx={{ maxWidth: "400px", maxHeight: "72px", alignItems: "center" }}
            onClose={() => {
              onAlertClose("monitoring");
            }}
          >
            {(!permissions.businessMonitoring || !permissions.complianceMonitoring) &&
            (checkBoxValues.addMatches || checkBoxValues.addNonMatches)
              ? "Your account is not currently contracted for monitoring. To change your contract terms, please contact your account manager"
              : "Please select Portfolio to Enable Monitoring"}
          </MzAlert>
        )}
      </Box>
    </Box>
  );
}

export default MonitoringConfiguration;
